import type { ComponentType } from 'react';
import {
  Sparkles,
  Users,
  Activity,
  UserCircle,
  BarChart3,
} from 'lucide-react';

export interface SidebarNavItem {
  label: string;
  icon: ComponentType<{ className?: string }>;
  path: string;
  dotColor?: string;
}

// DESIGN §1/§11: nav dots encode *which product* but stay in-palette — no
// green/violet/indigo/amber. Signal blue, ink, §6 warm-grey ramp only
// (mirrors tailwind.config.cjs `product.*` and style.css `--*-color`).
export const SIDEBAR_PRODUCT_ITEMS: SidebarNavItem[] = [
  { label: 'PharmaGEO', icon: Sparkles, path: '/dashboard/pharmageo', dotColor: 'var(--signal-blue)' }, // Signal (was #6366f1 indigo)
  { label: 'KOL Network', icon: Users, path: '/dashboard/kol', dotColor: 'var(--signal-blue)' }, // Signal (was #3B82F6 blue-500)
  { label: 'Medical Watch', icon: Activity, path: '/dashboard/medical-watch', dotColor: 'var(--grey-2)' }, // §6 warm grey 2 (was #10B981 emerald)
  { label: 'Persona Sandbox', icon: UserCircle, path: '/dashboard/personas', dotColor: 'var(--ink)' }, // ink (was #8B5CF6 violet)
  { label: 'Market Access', icon: BarChart3, path: '/dashboard/market-access', dotColor: 'var(--grey-3)' }, // §6 warm grey 3 (was #F59E0B amber)
];

export type SidebarAgentTab = 'medical' | 'marketing';

export const SIDEBAR_AGENT_META: Record<SidebarAgentTab, { name: string; role: string }> = {
  medical: { name: 'Dr. Claire', role: 'MSL Director' },
  marketing: { name: 'Alex', role: 'Brand Director' },
};
